import { useState } from "react";

export const ViewOrderDetailsPublish = () => {
    const [tab, setTab] = useState("tab-1");
    return (
        <>
            <div className="content_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">수주 상세보기</h3>
                    <div className="filter_toolbar">
                        <button className="btn btn-outline-primary w-100px h-38px"><img src={process.env.PUBLIC_URL + "/assets/images/icon_hamburger_btn.png"} alt="" />목록</button>
                        <button className="btn btn-secondary w-100px h-38px">수정</button>
                    </div>
                </div>
                <h5 className="subheading">기본정보</h5>
                <table className="table table-bordered my_table table_detail">
                    <tbody>
                        <tr>
                            <th style={{ width: "16.66%" }}>수주번호</th>
                            <td style={{ width: "33.3%" }}>1234_20240505_1</td>
                            <th style={{ width: "16.66%" }}>상태</th>
                            <td>수주</td>
                        </tr>
                        <tr>
                            <th>수주일자</th>
                            <td>2024-05-05</td>
                            <th>요청자</th>
                            <td>이소희</td>
                        </tr>
                        <tr>
                            <th>메모</th>
                            <td colSpan={3}>주문 시 고객이 입력한 메모 사항</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="mybtns_group">
                <div className="btn-group" role="group" aria-label="">
                    <button type="button" className={tab == "tab-1" ? "btn btn-light active" : "btn btn-light"} onClick={() => setTab("tab-1")}>수주정보</button>
                    <button type="button" className={tab == "tab-2" ? "btn btn-light active" : "btn btn-light"} onClick={() => setTab("tab-2")}>품목정보</button>
                </div>
                <div className="mybtns_group_toolbar">
                    <button className="btn btn-outline-primary w-80px">출하요청</button>
                </div>
            </div>

            <div className="content_wrap">
                <h5 className="subheading mt-0">고객정보</h5>
                <table className="table table-bordered my_table table_detail">
                    <tbody>
                        <tr>
                            <th style={{ width: "16.66%" }}>고객사</th>
                            <td style={{ width: "33.3%" }}>(주)구구구</td>
                            <th style={{ width: "16.66%" }}>발송요청일</th>
                            <td>2024.05.29</td>
                        </tr>
                        <tr>
                            <th>요청자 <span className="required">*</span></th>
                            <td>요청자</td>
                            <th>발송방법</th>
                            <td>택배</td>
                        </tr>
                        <tr>
                            <th>수신자</th>
                            <td>홍길동 대리</td>
                            <th>연락처</th>
                            <td>010-1234-4567</td>
                        </tr>
                        <tr>
                            <th>주소</th>
                            <td colSpan={3}>경기도 성남시 분당구 000 000000</td>
                        </tr>
                        <tr>
                            <th>메모</th>
                            <td colSpan={3}>월마감</td>
                        </tr>
                        <tr>
                            <th>기타사항</th>
                            <td colSpan={3}>기타사항</td>
                        </tr>
                    </tbody>
                </table>

                <h5 className="subheading">납품정보</h5>
                <table className="table table-bordered my_table table_detail">
                    <tbody>
                        <tr>
                            <th style={{ width: "16.66%" }}>납품처</th>
                            <td style={{ width: "33.3%" }}>주식회사 구구구</td>
                            <th style={{ width: "16.66%" }}>매출처</th>
                            <td>주식회사 구구구</td>
                        </tr>
                    </tbody>
                </table>

                <h5 className="subheading">수금정보</h5>
                <table className="table table-bordered my_table table_detail">
                    <tbody>
                        <tr>
                            <th style={{ width: "16.66%" }}>수금예정일<span className="required">*</span></th>
                            <td style={{ width: "33.3%" }}></td>
                            <th style={{ width: "16.66%" }}>결제방법<span className="required">*</span></th>
                            <td className="p-4px">
                                <select className="form-select w-150px">
                                    <option>현금</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <th>수금메모(세금계산서 비고)</th>
                            <td colSpan={3}></td>
                        </tr>
                        <tr>
                            <th>계산서담당자</th>
                            <td>김과장</td>
                            <th>연락처</th>
                            <td>010-1234-4567</td>
                        </tr>
                        <tr>
                            <th>이메일</th>
                            <td colSpan={3}>aaa@it.com</td>
                        </tr>
                    </tbody>
                </table>

                <h5 className="subheading">출하정보</h5>
                <table className="table table-bordered my_table table_detail mb-0">
                    <tbody>
                        <tr>
                            <th style={{ width: "16.66%" }}>출하일자</th>
                            <td style={{ width: "33.3%" }}></td>
                            <th style={{ width: "16.66%" }}>출하번호</th>
                            <td></td>
                        </tr>
                        <tr>
                            <th>요청자</th>
                            <td colSpan={3}></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </>
    );
}